import React from "react";
import { Row, Col, Form, Button, Select } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import { InputCpf } from "../InputCpf";

import { Wrapper } from "./styles";

const { Option } = Select;

export function SearchAudit({ onSearch, onClear, onReset }) {
  const [form] = Form.useForm();

  function handleReset() {
    onClear();
    form.resetFields();
    onReset();
  }

  function onSubmit(values) {
    onSearch(values);
  }

  return (
    <Wrapper>
      <div className="advance-search">
        <Form
          onFinish={onSubmit}
          layout="vertical"
          form={form}
          name="busca"
          key="busca"
        >
          <Row justify="center">
            <Col span={10} offset={1}>
              <Form.Item
                name="cpfAutorizador"
                label="CPF Autorizador Inteligência:"
                rules={[
                  {
                    validator: async (_, value) => {
                      const cpfSolicitante =
                        form.getFieldValue("cpfSolicitante");
                      if (!value && !cpfSolicitante) {
                        throw new Error(
                          "Preencha pelo menos um dos dois CPFs."
                        );
                      }
                    },
                  },
                ]}
              >
                <InputCpf style={{ borderRadius: 60, height: 32 }} />
              </Form.Item>
            </Col>
            <Col span={10} offset={1}>
              <Form.Item
                name="cpfSolicitante"
                label="CPF Solicitante:"
                rules={[
                  {
                    validator: async (_, value) => {
                      const cpfAutorizador =
                        form.getFieldValue("cpfAutorizador");
                      if (!value && !cpfAutorizador) {
                        throw new Error(
                          "Preencha pelo menos um dos dois CPFs."
                        );
                      }
                    },
                  },
                ]}
              >
                <InputCpf style={{ borderRadius: 60, height: 32 }} />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="center">
            <Col span={10} offset={1}>
              <Form.Item name="sistema" label="Sistema:">
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value="AGILIS">AGILIS</Option>
                  <Option value="CEREBRUM">CEREBRUM</Option>
                  <Option value="SIP3W">SIP3W</Option>
                  <Option value="CONSULTA_INTEGRADA">CONSULTA INTEGRADA</Option>
                  <Option value="ROTAS">ROTAS</Option>
                  <Option value="APOLO_SAP">APOLO SAP</Option>
                  <Option value="APOLO_PROCUMPRI">APOLO PROCUMPRI</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={10} offset={1}>
              <Form.Item name="aprovado" label="Status:">
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value={true}>APROVADO</Option>
                  <Option value={false}>REPROVADO</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row justify="end">
            <Col>
              <Button
                onClick={handleReset}
                icon={<ClearOutlined />}
                style={{ marginRight: 5 }}
              >
                Limpar
              </Button>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                style={{ marginRight: 20 }}
                htmlType="submit"
              >
                Buscar
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </Wrapper>
  );
}

SearchAudit.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onReset: PropTypes.func,
};

